<cip-blocking-spinner></cip-blocking-spinner>
<cip-site-header *ngIf="showHeader$ | async"></cip-site-header>

<router-outlet *ngIf="showOutlet$ | async"></router-outlet>
